import type { CSSProperties } from 'react'

export type ProgressBarPreviewState = 'default' | 'partial' | 'filled'

export const PROGRESS_BAR_PREVIEW_STATES: ProgressBarPreviewState[] = [
  'default',
  'partial',
  'filled',
]

export const PROGRESS_BAR_PREVIEW_STATE_LABELS: Record<
  ProgressBarPreviewState,
  string
> = {
  default: 'Default',
  partial: 'Partially filled',
  filled: 'Filled',
}

/** Showcase values for each preview state. */
export const PROGRESS_BAR_PREVIEW_VALUES: Record<
  ProgressBarPreviewState,
  number
> = {
  default: 0,
  partial: 45,
  filled: 100,
}

export type ProgressBarProps = {
  /** Progress value from 0–100. */
  value?: number
  /** Visible percentage label. Defaults to rounded `value%`. */
  label?: string
  /** Hide the centered percentage label. */
  hideLabel?: boolean
  /** Accepted for API parity; uses the same light-mode styles. */
  darkMode?: boolean
  className?: string
  style?: CSSProperties
  /** Static visual state for the design-system showcase only. */
  previewState?: ProgressBarPreviewState
  'aria-label'?: string
}
